import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import { withRouter } from 'react-router';
import { DebounceInput } from 'react-debounce-input';
import classNames from 'classnames';
import MerchantBanner from 'components/widgets/MerchantBanner';
import ZapCashBanner from 'components/widgets/ZapCashBanner';
import Loader from 'components/widgets/Loader';
import '../styles/merchants.less';

class Merchants extends React.Component {
  static propTypes = {
    relay: PropTypes.shape({
      setVariables: PropTypes.func,
      variables: PropTypes.object,
    }).isRequired,
    location: PropTypes.shape({
      query: PropTypes.shape({
        redemptionCurrencyId: PropTypes.string,
      }),
    }).isRequired,
    viewer: PropTypes.shape({
      zapperId: PropTypes.string,
      auth: PropTypes.shape({
        email: PropTypes.string,
      }),
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        birthday: PropTypes.string,
        gender: PropTypes.string,
        streetAddress: PropTypes.string,
        locationId: PropTypes.string,
        image: PropTypes.string,
      }),
      currencyBalance: PropTypes.shape({
        rawId: PropTypes.string,
        name: PropTypes.string,
        redeemable: PropTypes.number,
      }),
      merchants: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string,
              rawId: PropTypes.string,
              name: PropTypes.string,
              spiel: PropTypes.string,
              effectiveCashBackRate: PropTypes.number,
              image: PropTypes.string,
              hasRedeemableReward: PropTypes.bool,
              isZapCashAccepted: PropTypes.bool,
              isZapCashAwarded: PropTypes.bool,
              categories: PropTypes.arrayOf(PropTypes.string),
              branchCount: PropTypes.number,
              branch: PropTypes.shape({
                name: PropTypes.string,
                address: PropTypes.string,
              }),
              searchBranch: PropTypes.shape({
                name: PropTypes.string,
                address: PropTypes.string,
              }),
              activeRank: PropTypes.shape({
                rank: PropTypes.shape({
                  image: PropTypes.string,
                }),
              }),
            }),
          }),
        ),
      }),
    }).isRequired,
  };

  state = {
    loadingItems: false,
    openSearch: false,
    subcategoryFilters: [],
    keyword: '',
  };

  componentWillMount() {
    const { viewer, router } = this.props;
    let zapperId = viewer ? viewer.zapperId : null;
    if (zapperId && !this.isCompleteProfile()) {
      router.replace('/profile');
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('hashchange', (e) => this.hashchange(e));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('hashchange', this.hashchange);
  }

  setRedemptionCurrency(redemptionCurrencyId, bannerCurrencyId) {
    this.props.relay.setVariables(
      {
        redemptionCurrencyId: redemptionCurrencyId,
        bannerCurrencyId: bannerCurrencyId,
      },
      (e) => this.loadCallback(e),
    );
  }

  hashchange() {
    let currentRedemptionCurrency =
      this.props.relay.variables.redemptionCurrencyId || null;
    let newRedemptionCurrency =
      this.props.location.query.redemptionCurrencyId || null;
    let bannerCurrencyId =
      this.props.location.query.redemptionCurrencyId || '1';

    if (currentRedemptionCurrency !== newRedemptionCurrency) {
      this.setRedemptionCurrency(newRedemptionCurrency, bannerCurrencyId);
    }
  }

  isCompleteProfile() {
    let viewer = this.props.viewer;
    let profile = viewer.profile;
    let email = viewer.auth ? viewer.auth.email : viewer.auth;
    if (
      email &&
      profile.firstName &&
      profile.lastName &&
      profile.birthday &&
      profile.gender &&
      profile.locationId
    ) {
      return true;
    }
    return false;
  }

  handleScroll = () => {
    if (this.isParent()) {
      let maxFooterHeight = 572;
      let height = window.document.documentElement.scrollHeight;
      let position = maxFooterHeight + window.innerHeight * 2 + window.scrollY;
      if (position >= height && !this.state.loadingItems) {
        this.loadItems();
      }
    }
  };

  handleSort(e) {
    this.props.relay.setVariables(
      {
        sortBy: e.target.value,
      },
      (e) => this.loadCallback(e),
    );
  }

  handleSearch(e) {
    const { value } = e.target;
    this.setState({ keyword: value });
    this.props.relay.setVariables(
      {
        keyword: value,
      },
      (e) => this.loadCallback(e),
    );
  }

  loadItems() {
    this.props.relay.setVariables(
      {
        count: this.props.relay.variables.count + 10,
      },
      (e) => this.loadCallback(e),
    );
  }

  loadCallback(e) {
    if (e.done) {
      this.setState({ loadingItems: false });
    } else {
      this.setState({ loadingItems: true });
    }
  }

  toggleSearch() {
    this.setState({ openSearch: !this.state.openSearch });
  }

  isParent() {
    let hasChildren = this.props.children;
    if (hasChildren) {
      return false;
    }
    return true;
  }

  clickCategory(key) {
    let value = this.state[key] ? !this.state[key] : true;
    this.setState({ [key]: value });
  }

  clickSubcategory(key) {
    this.state.subcategoryFilters.push(key);
    this.forceUpdate();
  }

  clearSubcategoryFilter(key) {
    let subcategoryFilters = this.state.subcategoryFilters;
    let keyIndex = subcategoryFilters.indexOf(key);
    subcategoryFilters.splice(keyIndex, 1);
    this.setState({ subcategoryFilters: subcategoryFilters });
  }

  clearSubcategoryFilters() {
    this.setState({ subcategoryFilters: [] });
  }

  clearRedemptionCurrency() {
    this.props.relay.setVariables(
      {
        redemptionCurrencyId: null,
      },
      (e) => this.loadCallback(e),
    );
  }

  renderMerchantBanner(m) {
    let branchName = m.node.searchBranch
      ? m.node.searchBranch.name
      : m.node.branch.name;
    let branchAddress = m.node.searchBranch
      ? m.node.searchBranch.address
      : m.node.branch.address;
    let rankImage = m.node.activeRank ? m.node.activeRank.rank.image : null;

    return (
      <MerchantBanner
        key={m.node.rawId}
        nodeId={m.node.id}
        parent
        merchantName={m.node.name}
        logo={m.node.image}
        location={branchName}
        address={branchAddress}
        cashBack={m.node.effectiveCashBackRate}
        categories={m.node.categories}
        hasRedeemableReward={m.node.hasRedeemableReward}
        isZapCashAccepted={m.node.isZapCashAccepted}
        isZapCashAwarded={m.node.isZapCashAwarded}
        rankImage={rankImage}
        branchCount={m.node.branchCount}
        spiel={m.node.spiel}
      />
    );
  }

  renderCategory(c) {
    let key = c.node.name + '-category';
    let expandClass = classNames({ expand: this.state[key] });

    return (
      <div key={key} className={expandClass}>
        <div className="category" onClick={() => this.clickCategory(key)}>
          {c.node.name}
        </div>
        <div className="subcategories">
          {c.node.subcategories.map((s) => this.renderSubCategory(s))}
        </div>
      </div>
    );
  }

  renderSubCategory(key) {
    let keySubcategory = key + '-subcategory';
    let subCategoryClass = classNames('subcategory', {
      selected: this.state.subcategoryFilters.indexOf(key) > -1,
    });

    return (
      <div
        key={keySubcategory}
        className={subCategoryClass}
        onClick={() => this.clickSubcategory(key)}
      >
        {key}
      </div>
    );
  }

  renderSubcategoryFilter(key) {
    let keyFilter = key + '-filter';
    return (
      <div
        key={keyFilter}
        className="filter"
        onClick={() => this.clearSubcategoryFilter(key)}
      >
        {key}
      </div>
    );
  }

  render() {
    let currencyId, currencyName, currencyBalance;

    if (this.props.viewer.currencyBalance) {
      let c = this.props.viewer.currencyBalance;
      currencyName = c.name;
      currencyBalance = c.redeemable;
      currencyId = c.rawId;
    }

    let merchants = this.props.viewer.merchants.edges;

    let searchContainerClass = classNames('search-container', {
      in: this.state.openSearch,
      logged: this.props.viewer.zapperId,
      'has-banner': currencyBalance > 0,
    });
    let merchantContainerClass = classNames({
      down: this.state.openSearch,
      'has-banner': currencyBalance > 0,
    });

    let sortClass = classNames('sort', { hide: this.state.openDrawer });

    let searchBtnClass = classNames('search-btn', {
      hide: this.state.openDrawer,
    });

    if (this.isParent()) {
      return (
        <div id="merchants-container" className={merchantContainerClass}>
          <div className="offwhite-bg" />
          <div className="section-border">
            <div className="section-title">Merchants</div>
          </div>

          <ZapCashBanner
            id={currencyId}
            currency={currencyName}
            balance={currencyBalance}
          />

          <div className="body">
            <div className={'merchants'}>
              <div className="filters">
                <span className="label">SORT BY</span>

                <select
                  className={sortClass}
                  onChange={(e) => this.handleSort(e)}
                >
                  <option value="ALPHABETICAL">Alphabetical</option>
                  <option value="HIGHEST_CASHBACK_RATE">
                    Highest Cashback
                  </option>
                  <option value="NEAREST_BRANCH">Nearest Branch</option>
                </select>
                <button
                  className={searchBtnClass}
                  onClick={() => this.toggleSearch()}
                />
                <div className={searchContainerClass}>
                  <DebounceInput
                    className="search"
                    minLength={3}
                    debounceTimeout={300}
                    onChange={(value) => this.handleSearch(value)}
                    placeholder="Search"
                    value={this.state.keyword}
                  />
                </div>
              </div>
              {merchants.map(this.renderMerchantBanner)}
              <Loader loading={this.state.loadingItems} />
            </div>
          </div>
        </div>
      );
    }
    return React.cloneElement(this.props.children, {
      zapperId: this.props.viewer.zapperId,
    });
  }
}

export default Relay.createContainer(withRouter(Merchants), {
  initialVariables: {
    count: 10,
    sortBy: 'ALPHABETICAL',
    keyword: '',
    redemptionCurrencyId: null,
    bannerCurrencyId: '1',
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        auth {
          email,
        },
        profile {
          firstName,
          lastName,
          birthday,
          gender,
          locationId,
          image(size: "140x140")
        },
        currencyBalance(id: $bannerCurrencyId) {
          rawId,
          name,
          redeemable
        },
        merchants(sortBy: $sortBy, search: $keyword, first: $count, redemptionCurrencyId: $redemptionCurrencyId) {
          edges {
            node {
              id,
              rawId,
              name,
              spiel,
              categories,
              isZapCashAccepted,
              isZapCashAwarded,
              hasRedeemableReward,
              branchCount,
              effectiveCashBackRate,
              image(size: "180x180"),
              branch {
                name,
                address
              },
              searchBranch: branch(search: $keyword) {
                name,
                address
              },
              activeRank {
                rank {
                  image
                }
              }
            }
          }
        },
        zapperId
      }`,
  },
});



// WEBPACK FOOTER //
// ./js/components/pages/Merchants.js